import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
`

const Input = styled.input`
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.surface};
  position: relative;
  transition: all 0.2s;

  &:checked {
    background: ${({ theme }) => theme.colors.primary};
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 5px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  &:focus {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primary}33;
  }
`

const LabelText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
`

export function Checkbox({ label, checked, onChange, ...props }) {
  return (
    <Wrapper>
      <Input 
        type="checkbox" 
        checked={checked} 
        onChange={(e) => onChange && onChange(e.target.checked)} 
        {...props} 
      />
      {label && <LabelText>{label}</LabelText>}
    </Wrapper>
  )
}
